import Vue from 'vue'
import router from '../router'
import laravelDriver from '../websanova-laravel-driver.js'

Vue.router = router

// Vue Auth
Vue.use(require('@websanova/vue-auth/src/index.js'), {
    auth: laravelDriver,
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    logoutData: { makeRequest: true },
    authRedirect: { path: '/login' },
    notFoundRedirect: { path: '/login' },
    forbiddenRedirect: { path: '/login' },
    refreshData: {
        url: 'auth/refresh-token',
        method: 'POST',
    },
    fetchData: {
        url: 'auth/me',
    },
    parseUserData: function(data) {
        return data
    },
})
